import { takeLatest, put, call, select } from "redux-saga/effects";
import log from "loglevel"

import getEnvParam from "../../utils/getEnvParam";
import { requestDefaultJson } from './helpers'

const getFreeGatesFromApi = (idLoad, token, perfil = []) => {
	const endpoint = perfil.indexOf('NPFornec_Renner_Logistica') !== -1 || perfil.indexOf('NPFornec_Renner_Admin') !== -1 ? '/agendamento/horariosdisponiveiscd/' : '/agendamento/horariosdisponiveis/';
	return requestDefaultJson({
		method: "GET",
		URIComplete: getEnvParam("REACT_APP_BFF_URL_REST") 
			+ endpoint + idLoad,
		headers: {
			"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_AGENDAMENTO"),
			"Authorization": token,
		}
	});
};

//generators
function* getFreeGatesAsync({payload}) {
	try {
		yield put({ type: "GET_FREE_GATES_LOADING"});

		const { token } = yield select(state => state.authentication)

		const { permissions } = yield select(state => state.authorization)

		let data = yield call(getFreeGatesFromApi, payload, token, permissions);

		if(data.cdDto) {
			yield put({ type: "GET_FREE_GATES_ASYNC", payload: data.cdDto});
		}
	} catch (error) {
		if (error.response && error.response.data) {
			yield put({ type: "GET_FREE_GATES_ERROR", payload: error.response.data.message});
		} else {
			yield put({ type: "GET_FREE_GATES_ERROR", payload: error.message});
		}
		log.info(error);
	}
}

// //Generator function
export function* getFreeGatesWatcher() {
	yield takeLatest("GET_FREE_GATES", getFreeGatesAsync);
}
